import { axiosAuthInstance } from "./auth.axios";

export default function setupAxios(axios) {
    axios.interceptors.request.use(
        config => {
            const authToken = JSON.parse(localStorage.getItem("authToken"));
            if (authToken) {
                config.headers.Authorization = `Bearer ${authToken}`;
            }
            // config.withCredentials = true;
            if (config.url === "upload/upload-image" || config.url === "upload/upload-image-file") {
                config.baseURL = `${process.env.REACT_APP_UPLOAD_HOST}/${process.env.REACT_APP_API_PATH}/`;
            } else {
                config.baseURL =
                    config.baseURL === "medicine"
                        ? `${process.env.REACT_APP_HOST_MEDICINE}/${process.env.REACT_APP_API_PATH}/`
                        : config.baseURL === "payment"
                        ? `${process.env.REACT_APP_HOST_PAYMENT}/${process.env.REACT_APP_API_PATH}/`
                        : config.baseURL || `${process.env.REACT_APP_HOST}/${process.env.REACT_APP_API_PATH}/`;
            }
            return config;
        },
        err => Promise.reject(err),
    );

    axios.interceptors.response.use(
        response => {
            return response;
        },
        async error => {
            const originalRequest = error.config;
            if (error?.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                const { status, data } = await axiosAuthInstance.get("auth/web-refresh");
                if (status === 200) {
                    localStorage.setItem("authToken", JSON.stringify(data?.access_token));
                    const authToken = JSON.parse(localStorage.getItem("authToken"));
                    if (authToken) {
                        axios.defaults.headers.Authorization = `Bearer ${authToken}`;
                    }
                    return axios(originalRequest);
                }
            }
            return Promise.reject(error);
        },
    );
}
